<template>
<div>
    <invoice-form :invoiceFormPropsFunctions="invoiceFormPropsFunctions" :getInvoiceList="getInvoiceList" ref="invoiceFormModal"></invoice-form>
    <div class="custom-search">
        <b-row>
            <b-col class="col-md-2">
                <label for="invoice-debit-no-input">{{ $t('invoice.debit_no') }}</label>
                <b-form-group>
                    <b-form-input v-on:keyup.enter="getInvoiceList()" size="sm" v-model="debitNo" :placeholder="$t('invoice.debit_no')" type="text" class="d-inline-block" />
                </b-form-group>
            </b-col>
            <b-col class="col-md-2">
                <label for="invoice-matter-no-input">{{ $t('invoice.matter_no') }}</label>
                <b-form-group>
                    <b-form-input v-on:keyup.enter="getInvoiceList()" size="sm" v-model="lawMatterNo" :placeholder="$t('invoice.matter_no')" type="text" class="d-inline-block" />
                </b-form-group>
            </b-col>
            <b-col class="col-md-2">
                <label for="invoice-agent-name-input">{{ $t('invoice.agent_name') }}</label>
                <b-form-group>
                    <b-form-input v-on:keyup.enter="getInvoiceList()" size="sm" v-model="invoiceClient" :placeholder="$t('invoice.agent_name')" type="text" class="d-inline-block" />
                </b-form-group>
            </b-col>
            <b-col class="col-md-2">
                <label for="invoice-account-no-input">{{ $t('invoice.account_no') }}</label>
                <b-form-group>
                    <b-form-input size="sm" v-on:keyup.enter="getInvoiceList()" v-model="invoiceClientAccountingNo" :placeholder="$t('invoice.account_no')" type="text" class="d-inline-block" />
                </b-form-group>
            </b-col>
            <b-col class="col-md-2">
                <label for="invoice-status-input">{{ $t('invoice.status') }}</label>
                <b-form-select @change="getInvoiceList()" id="invoice-status-input" :placeholder="$t('invoice.status')" size="sm" v-model="statusSelect" value-field="id" text-field="name" :options="statusOption" />
            </b-col>
            <b-col class="col-md-2">
                <label for="invoice-employee-input">{{ $t('invoice.employee') }}</label>
                <b-form-select @change="getInvoiceList()" id="invoice-employee-input" :placeholder="$t('invoice.employee')" size="sm" v-model="employeeSelect" value-field="id" text-field="name" :options="employeeOption" />
            </b-col>
        </b-row>
        <b-row class="mt-1 mb-2 align-items-end">
            <b-col class="col-md-2">
                <label>Başlangıç Tarihi</label>
                <b-form-datepicker size="sm" v-model="startDate" reset-button today-button :label-today-button="$t('dateTime.today')" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
            </b-col>
            <b-col class="col-md-2">
                <label>Bitiş Tarihi</label>
                <b-form-datepicker size="sm" v-model="endDate" reset-button today-button :label-today-button="$t('dateTime.today')" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
            </b-col>
            <b-col class="col-md-8 custom-search d-flex justify-content-end align-items-center">
                <b-button style="float:right;" class="mr-1" size="sm" variant="outline-primary" @click="getInvoiceList()">{{ $t('invoice.list') }}</b-button>
                <b-button style="float:right; border-color:#6B7280; color:#374151;" class="mr-1" size="sm" variant="outline-secondary" @click="getInfo(0)">{{ $t('matter.add') }}</b-button>
                <b-button style="float:right; border-color:#6B7280; color:#374151;" size="sm" variant="outline-secondary" @click="exportExcel()">{{ $t('others.excel') }}</b-button>
            </b-col>
        </b-row>
    </div>
    <!-- table -->
    <vue-good-table id="invoiceTable" ref="invoiceTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
          enabled: true,
          externalQuery: searchTerm
        }" :select-options="{
          enabled: false,
          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
          selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
        }" :pagination-options="{
          enabled: true,
          perPage: pageLength
        }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'debitNo'" class="text-nowrap">
                {{ $t('invoice.debit_no') }}
            </span>
            <span v-else-if="props.column.field === 'lawMatterRecordNo'" class="text-nowrap">
                {{ $t('invoice.matter_no') }}
            </span>
            <span v-else-if="props.column.field === 'invoiceClient'" class="text-nowrap">
                {{ $t('invoice.agent_name_accounting_no') }}
            </span>
            <span v-else-if="props.column.field === 'total'" class="text-nowrap">
                {{ $t('invoice.amount') }}
            </span>
            <span v-else-if="props.column.field === 'currency'" class="text-nowrap">
                {{ $t('invoice.currency_code') }}
            </span>
            <span v-else-if="props.column.field === 'date'" class="text-nowrap">
                {{ $t('invoice.proforma_date') }}
            </span>
            <span v-else-if="props.column.field === 'lawInvoiceStatus'" class="text-nowrap">
                {{ $t('invoice.status') }}
            </span>
            <span v-else-if="props.column.field === 'employee'" class="text-nowrap">
                {{ $t('invoice.employee') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap"></span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Process -->
            <span v-if="props.column.field === 'date'">
                <span style="font-size: smaller;">
                    {{$formatFn(props.row.date) }}
                </span>
            </span>
            <span v-else-if="props.column.field === 'total'">
                <span style="font-size: smaller;">
                    {{ $formatMoneyTr(props.row.total) }}
                </span>
            </span>
            <span v-else-if="props.column.field === 'lawMatterRecordNo'">
                <div v-b-tooltip.hover="{ title: $formatMatterNos(props.row.lawMatterRecordNo), customClass: 'wh-tooltip' }" class="wh-clamp-2">{{ $formatMatterNos(props.row.lawMatterRecordNo) }}</div>
            </span>
            <span v-else-if="props.column.field === 'lawInvoiceStatus'">
                <b-badge :style="$badgeStyle(invoiceStatusKind(props.row.lawInvoiceStatus))">
                    {{ translateInvoiceStatus(props.row.lawInvoiceStatus) }}
                </b-badge>
            </span>

            <span v-else-if="props.column.field === 'process'">
                <list-actions-dropdown :actions="[
                    { icon: 'EditIcon', label: $t('others.edit'), handler: () => getInfo(props.row.id) },
                    { icon: 'FileTextIcon', label: $t('others.show_invoice'), handler: () => downloadInvoicePdf(props.row.id) },
                    { icon: 'UnlockIcon', label: $t('others.ToReturn'), color: '#2563EB', show: props.row.lawInvoiceStatusId == 3 && letToReturn(), handler: () => changeStatus(props.row.id) },
                    { icon: 'XIcon', label: $t('others.delete'), color: '#DC2626', show: props.row.lawInvoiceStatusId == 1, handler: () => deleted(props.row) }
                ]" />
            </span>
        </template>
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}</span>
                    <b-form-select size="sm" v-model="pageLength" :options="['10','25','50','100']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" />
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getInvoiceList()">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    data() {
        return {
            total: 0,
            pageLength: 50,
            dir: false,
            pageNo: 1,
            invoiceFormPropsFunctions: 5,
            columnsForExcel: [{
                    label: this.$t('invoice.debit_no'),
                    field: `debitNo`,
                },
                {
                    label: this.$t('invoice.proforma_date'),
                    field: `date`,
                },
                {
                    label: this.$t('invoice.matter_no'),
                    field: `lawMatterRecordNo`,
                },
                {
                    label: this.$t('invoice.agent_name_accounting_no'),
                    field: `invoiceClient`,
                },
                {
                    label: this.$t('invoice.amount'),
                    field: `total`,
                },
                {
                    label: this.$t('invoice.currency_code'),
                    field: `currency`,
                },
                {
                    label: this.$t('invoice.status'),
                    field: `lawInvoiceStatus`,
                },
            ],
            columns: [{
                    label: this.$t('invoice.debit_no'),
                    field: `debitNo`,
                },
                {
                    label: this.$t('invoice.matter_no'),
                    field: `lawMatterRecordNo`,
                    width: '12em',
                },
                {
                    label: this.$t('invoice.agent_name_accounting_no'),
                    field: `invoiceClient`,
                },
                {
                    label: this.$t('invoice.amount'),
                    field: `total`,
                    width: '9em',
                    tdClass: 'text-right col-amount',
                    thClass: 'text-right col-amount',
                },
                {
                    label: this.$t('invoice.currency_code'),
                    field: `currency`,
                    width: '6em',
                    tdClass: 'col-currency',
                    thClass: 'col-currency',
                },
                {
                    label: this.$t('invoice.proforma_date'),
                    field: `date`,
                },
                {
                    label: this.$t('invoice.status'),
                    field: `lawInvoiceStatus`,
                },
                {
                    label: this.$t('invoice.employee'),
                    field: `employee`,
                },
                {
                    label: 'Process',
                    field: 'process',
                    width: '8em',
                    sortable: false
                },
            ],
            rows: [],
            searchTerm: '',
            debitNo: '',
            lawMatterNo: '',
            invoiceClient: '',
            employeeSelect: 0,
            employeeOption: [],
            invoiceClientAccountingNo: '',
            statusSelect: 0,
            statusOption: [],
            paid: true,
            notPaid: false,
            count: '',
            startDate: null,
            endDate: null,
            searchDebounce: null
        }
    },
    mounted() {
        this.getInvoiceList()
    },
    watch: {
        debitNo() { this.debouncedSearch() },
        lawMatterNo() { this.debouncedSearch() },
        invoiceClient() { this.debouncedSearch() },
        invoiceClientAccountingNo() { this.debouncedSearch() }
    },
    methods: {
        async deleted(data) {
            this.count = data.lawInvoiceDetailCount
            data = {
                id: data.id
            }
            const controller = {
                name: 'LawInvoice'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$DeleteInvoiceConfirm(this.count).then(result => {
                if (result.value) {
                    this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$DeleteAlert()
                            this.getInvoiceList()
                        } else {
                            if (response.data.resultMessage == 'ThereIsAInvoiceDetailInThisRecord') {
                                this.$InvoiceDetailError()
                            } else {
                                this.$CustomWarningAlert(response.data.resultMessage)
                            }
                            this.getInvoiceList()
                        }
                    })
                }
            })
        },
        async getInfo(id) {
            this.$refs.invoiceFormModal.showInfo(id)
        },
        getInvoiceList() {
            this.rows = []
            const controller = {
                name: 'LawInvoice'
            }
            const data = {
                pageLength: this.pageLength,
                pageNo: this.pageNo,
                debitNo: this.debitNo,
                lawMatterNo: this.lawMatterNo,
                lawInvoiceTypeId: 0,
                invoiceClient: this.invoiceClient,
                employeeId: this.employeeSelect,
                invoiceClientAccountingNo: this.invoiceClientAccountingNo,
                lawInvoiceStatusId: this.statusSelect,
                startDate: this.startDate || null,
                endDate: this.endDate || null
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getList', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.total = response.data.total
                    this.employeeOption = response.data.employeeList
                    this.statusOption = response.data.lawInvoiceStatusList.map(s => ({ id: s.id, name: this.translateInvoiceStatus(s.name) }))
                    response.data.lawInvoiceList.forEach(element => {
                        this.rows.push(element)
                    })
                    this.statusOption.splice(0, 0, this.$nullSelected()),
                        this.employeeOption.splice(0, 0, this.$nullSelected())
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        exportExcel() {
            const controller = {
                name: 'LawInvoice'
            }
            const data = {
                pageLength: 20000,
                pageNo: 1,
                debitNo: this.debitNo,
                lawMatterNo: this.lawMatterNo,
                lawInvoiceTypeId: 0,
                invoiceClient: this.invoiceClient,
                employeeId: this.employeeSelect,
                invoiceClientAccountingNo: this.invoiceClientAccountingNo,
                lawInvoiceStatusId: this.statusSelect,
                startDate: this.startDate || null,
                endDate: this.endDate || null
            }
            const payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/getList', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    const exportController = {
                        name: 'LawInvoice',
                        actionName: 'CanExport'
                    }
                    const exportData = {
                        columnList: this.columnsForExcel,
                        DataList: response.data.lawInvoiceList
                    }
                    const exportPayload = {
                        data: exportData,
                        controller: exportController
                    }
                    this.$store.dispatch('moduleAuth/customService', exportPayload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$downloadFile("Invoice", response.data.base64, 'xlsx')
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
        async downloadInvoicePdf(id) {
            var data = {
                id: id
            }
            var controller = {
                name: 'LawInvoice'
            }
            var payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    data = {
                        lawInvoice: response.data.lawInvoice,
                        lawInvoiceDetailList: response.data.lawInvoiceDetailList
                    }
                    controller = {
                        name: 'LawInvoice',
                        actionName: 'DownloadProforma'
                    }
                    payload = {
                        data: data,
                        controller: controller
                    }
                    this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$downloadFile(response.data.document.name, response.data.base64, response.data.document.type)
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
        changeStatus(id) {
            this.$PrivateConfirm(this.$t("invoiceApproval.confirmTitleReturnInvoice"), this.$t("invoiceApproval.confirmMessageReturnInvoice"), "warning", this.$t("invoiceApproval.confirmButtonTextReturnInvoice"), this.$t("invoiceApproval.cancelButtonTextReturnInvoice")).then(result => {
                if (result.value) {
                    const data = {
                        lawInvoiceId: id,
                        lawInvoiceStatusId: 1
                    }
                    const controller = {
                        name: 'LawInvoice',
                        actionName: 'ChangeLawInvoiceStatus'
                    }
                    const payload = {
                        data: data,
                        controller: controller
                    }
                    this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                        if (response.data.resultStatus == true) {

                            this.getInvoiceList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
        letToReturn() {
            const roleId = parseInt(localStorage.getItem("RoleId"))
            const departmentId = parseInt(localStorage.getItem("DepartmentId"))
            if (roleId === 1 || departmentId === 2) return true;
            return false
        },
        translateInvoiceStatus(name) {
            const map = {
                ToBeSent: this.$t('invoice.status_tobesent'),
                Unpaid: this.$t('invoice.status_unpaid'),
                Paid: this.$t('invoice.status_paid'),
                Cancelled: this.$t('invoice.status_cancelled'),
                Canceled: this.$t('invoice.status_cancelled')
            }
            return map[name] || name
        },
        invoiceStatusKind(name) {
            const map = { Paid: 'success', Unpaid: 'danger', ToBeSent: 'info', Cancelled: 'warning', Canceled: 'warning' }
            return map[name] || 'neutral'
        },
        debouncedSearch() {
            clearTimeout(this.searchDebounce)
            this.searchDebounce = setTimeout(() => {
                this.pageNo = 1
                this.getInvoiceList()
            }, 300)
        }
    }
}
</script>

<style lang="scss">
.excel-css {
    float: right;
    margin-right: 1em;
    width: 9.5em;
    color: #7367f0;
    border: 1px solid #7367f0;
    background-color: transparent;
    margin-left: 1em;
    height: 2em;
    border-radius: 0.358rem;
}

.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}

.datepickerStyle {
    max-height: 2.2em;
    font-family: fangsong;
}

.col-amount { min-width: 9em !important; }
.col-currency { min-width: 6em !important; }
</style>
